import React, { useEffect, useState, useRef } from 'react';
import Navbar from '../Navbar/Navbar.jsx';
import Footer from '../Footer/Footer.jsx';
import HomeOne from './HomeOne.jsx';
import HomeThree from './HomeThree.jsx';
import HomeSix from './HomeSix.jsx';
import HomeCustomer from './HomeCustomer.jsx';
import MoneyBackGuarantee from './MoneyBackGuarantee.jsx';
import HomeIngredient from './HomeIngredient.jsx';
 
 
const HomeMain = () => {
   const widgetRef = useRef(null);
  const scriptLoadedRef = useRef(false);
 

  return (
    <div className="relative">
      <div >
        <Navbar />
        <HomeOne />
        <HomeCustomer />  
        <HomeIngredient />

        {/* <HomeThree /> */}
        <HomeSix />
        <MoneyBackGuarantee />
        <Footer />
      </div>
 
     
    </div>
  );
};
 
export default HomeMain;
 